export const PROVIDER_SCOPE = 'provider:scope';
export const PROVIDER_DEPENDENCIES = 'provider:dependencies';
export const PROVIDER_GROUPS = 'provider:groups';
//# sourceMappingURL=provider.meta.js.map